import { Check } from "lucide-react";
import { EngineeringSystem } from "./engineering-system";
import { Reveal, ScrollHeading, Eyebrow } from "./ui";
const features = [
  {
    title: "Advice you can act on",
    description:
      "Clear recommendations, explained trade-offs, and a plan that connects technical decisions to your business priorities.",
  },
  {
    title: "Faster iteration with AI",
    description:
      "Where it adds value, we use AI to speed up prototyping and repetitive development work. Engineering review and testing remain part of the process.",
  },
  {
    title: "Built for the next step",
    description:
      "We focus on maintainable code, sensible architecture, and the ability to adapt as your requirements change.",
  },
  {
    title: "Collaboration throughout",
    description:
      "Regular reviews keep you involved in the work, with visibility into progress, open questions, and scope changes.",
  },
];

export function WhyUs() {
  return (
    <section id="why-us" className="why-us section-pad">
      <div className="wrap why-layout">
        <div>
          <Reveal>
            <Eyebrow number="04">Why QuantumCode</Eyebrow>
            <ScrollHeading
              lines={[
                { text: "Technical expertise.", muted: false },
                { text: "A practical partner.", muted: true },
              ]}
            />
            <p className="why-intro">
              Work with us on a complete build or a focused technical challenge.
              We can help shape a solution, develop it, or work alongside your
              existing team.
            </p>
          </Reveal>
          <div className="feature-list">
            {features.map((feature, i) => (
              <Reveal key={feature.title} className="feature" delay={i * 0.04}>
                <Check size={18} strokeWidth={1.5} />
                <div>
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
        <Reveal className="engineering-system-wrap">
          <EngineeringSystem />
        </Reveal>
      </div>
    </section>
  );
}
